var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gateway-status-timeline-container"},[_c('InfiniteTimeline',{attrs:{"items":_vm.items,"display-header":_vm.showHeader,"is-loading":_vm.isLoading,"has-more-data":_vm.hasMoreSpaceStatusData,"left-header":'Start',"right-header":'End'},on:{"moreData":_vm.getMoreData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }